import React from 'react';
import { RuleSet } from 'styled-components';
import { Currency } from './styled';
import { getSymbolFromCurrency } from '../../../utils/helpers/getSymbolFromCurrency';
import ManatIcon from '../../../public/static/images/currency/manat-brown.svg';
import Icon from '../../Icon';

const USE_MANAT_ICON_SVG = false;

export const CurrencySymbol = ({
  currency,
  iconStyles,
  wrapperStyles,
  useManatIconSvg = USE_MANAT_ICON_SVG
}: {
  currency: string;
  iconStyles?: RuleSet<object>;
  wrapperStyles?: RuleSet<object>;
  useManatIconSvg?: boolean;
}) => {
  const isManatIcon = useManatIconSvg && currency === 'AZN';

  return (
    <Currency
      $isManatIcon={isManatIcon}
      $iconStyles={iconStyles}
      $wrapperStyles={wrapperStyles}
    >
      {isManatIcon ? (
        <Icon IconComponent={ManatIcon} width={11} height={11} />
      ) : (
        getSymbolFromCurrency(currency)
      )}
    </Currency>
  );
};
